/**
 * Utility functions for sharing link permissions display
 * Maps internal permission types to user-friendly SharePoint-style labels
 */

import { getSharingLinkPermissionsTypePrimaryLabelKey } from './shared-links';
import { ILocaleStrings } from 'loc/locale.interfaces';

/**
 * Maps sharing link permission type ID to user-friendly display text
 * @param permissionType The permission type ID (0=Edit, 1=Review, 2=Read, 3=ReadNoDownload)
 * @param t Translation function for localization
 * @returns User-friendly permission text like "Can edit", "Can view", etc.
 */
export const getSharingLinkPermissionDisplayText = (permissionType: number | undefined, t: (key: keyof ILocaleStrings) => string): string => {
    if (permissionType === undefined) {
        return t("unknown");
    }
    
    const localeKey = getSharingLinkPermissionsTypePrimaryLabelKey(permissionType);
    return t(localeKey);
};

/**
 * Maps sharing link permission type ID to short display text (for compact views)
 * @param permissionType The permission type ID
 * @param t Translation function for localization
 * @returns Short permission text like "Edit", "View", etc.
 */
export const getSharingLinkPermissionShortText = (permissionType: number | undefined, t: (key: keyof ILocaleStrings) => string): string => {
    if (permissionType === undefined) {
        return t("unknown");
    }
    
    const localeKey = getSharingLinkPermissionsTypePrimaryLabelKey(permissionType);
    return t(localeKey);
};